import React from "react";
import Tool from "../../../../../Base/Tool";

export default function Notify({ updateForm, form, onChangeInput }) {
  return (
    <div className="profile">
      <h5>
        <span className="orange"></span> Notifications
      </h5>
      <div className="profile__opt">
        <div className="profile__opt-text">
          <p className="sm">Product updates and community announcements </p>
          <Tool text="Product updates and community announcements" />
        </div>
        <div className="opt">
          <input
            type="checkbox"
            checked={form.updates}
            onChange={(e) => updateForm({ updates: e.target.checked })}
          />
          <label htmlFor=""></label>
        </div>
      </div>
      <div className="profile__opt">
        <div className="profile__opt-text">
          <p className="sm">Market newsletter</p>
          <Tool text="Product updates and community announcements" />
        </div>
        <div className="opt">
          <input
            type="checkbox"
            checked={form.newsletter}
            onChange={(e) => updateForm({ newsletter: e.target.checked })}
          />
          <label htmlFor=""></label>
        </div>
      </div>
      <div className="profile__opt">
        <div className="profile__opt-text">
          <p className="sm">Purchases</p>
          <Tool text="Product updates and community announcements" />
        </div>
        <div className="opt">
          <input
            type="checkbox"
            checked={form.purchases}
            onChange={(e) => updateForm({ purchases: e.target.checked })}
          />
          <label htmlFor=""></label>
        </div>
      </div>
    </div>
  );
}

// import React from "react";

// export default function Notify() {
//   return (
//     <div className="profile">
//       <h5>
//         <span></span> Profile information
//       </h5>
//       <ChooseImage imageData={form.avatar} updateForm={updateForm} />
//       <div className="input__outer">
//         <label htmlFor="">
//           Display name
//           <Tool text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverunt sed montes, quis." />
//         </label>
//         <div className="input">
//           <input
//             type="text"
//             placeholder="Display name"
//             value={form.name}
//             onChange={onChangeInput("name")}
//           />
//         </div>
//       </div>
//       <div className="input__outer">
//         <label htmlFor="">
//           Description{" "}
//           <Tool text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverunt sed montes, quis." />
//         </label>
//         <div className="input">
//           <textarea
//             name=""
//             id=""
//             cols="30"
//             rows="3"
//             value={form.description}
//             onChange={onChangeInput("description")}
//           ></textarea>
//         </div>
//       </div>
//       <div className="profile__links">
//         <div className="input__outer">
//           <label htmlFor="">
//             Facebook
//             <Tool text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverunt sed montes, quis." />
//           </label>
//           <div className="input wS">
//             <input
//               type="text"
//               placeholder="www.facebook.com"
//               value={form.facebookLink}
//               onChange={onChangeInput("facebookLink")}
//             />
//             {faceIcon}
//           </div>
//         </div>
//         <div className="input__outer">
//           <label htmlFor="">
//             Telegram
//             <Tool text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverunt sed montes, quis." />
//           </label>
//           <div className="input wS">
//             <input
//               type="text"
//               placeholder="www.telegram.com"
//               value={form.telegramLink}
//               onChange={onChangeInput("telegramLink")}
//             />
//             {telegaIcon}
//           </div>
//         </div>
//         <div className="input__outer">
//           <label htmlFor="">
//             LinkedIn
//             <Tool text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Viverunt sed montes, quis." />
//           </label>
//           <div className="input wS">
//             <input
//               type="text"
//               placeholder="www.linkedin.com"
//               value={form.linkedinLink}
//               onChange={onChangeInput("linkedinLink")}
//             />
//             {faceIcon}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
